import React, { Component } from 'react'

export class Tutorials extends Component {
  render() {
    return (
      <div>Tutorials</div>
    )
  }
}

export default Tutorials